/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain

class TimeoutException : ApiException(message = "Timeout.")